import { Ref } from 'vue'

import { Participant } from '@collector/sportsapi-client-legacy'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'
import { useEventId } from '@desktop/views/Relation/composables/useEventId'
import {
  queryOptions,
  useQuery,
  type UndefinedInitialQueryOptionsWithDataTag,
  type UseQueryReturnType,
} from '@tanstack/vue-query'

type ParticipantsQueryKey = readonly ['event', 'participants', Ref<number>]

type ParticipantsQueryOptions = UndefinedInitialQueryOptionsWithDataTag<
  Participant[],
  Error,
  Participant[],
  ParticipantsQueryKey
>

export function participantsQueryOptions(
  eventId: Ref<number>,
): ParticipantsQueryOptions {
  return queryOptions({
    queryKey: ['event', 'participants', eventId] as const,
    queryFn: async (): Promise<Participant[]> => {
      const response = await sportsApiClient.Events.Participants.get(
        eventId.value,
      )
      return response.api.data.participants as Participant[]
    },
  })
}

export const useParticipantsQuery = (
  options?: Omit<ParticipantsQueryOptions, 'queryKey' | 'queryFn'>,
): UseQueryReturnType<Participant[], Error> => {
  const eventId = useEventId()
  return useQuery<Participant[], Error, Participant[], ParticipantsQueryKey>({
    ...participantsQueryOptions(eventId),
    ...options,
  })
}
